import { render, staticRenderFns } from "./apexChartRatio.vue?vue&type=template&id=1d1bfa7c&"
import script from "./apexChartRatio.vue?vue&type=script&lang=js&"
export * from "./apexChartRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports